module.exports = __webpack_public_path__ + "static/grzesiak_main_1-69014a7aa58d19d342c92b370f902f99.png";